const actionTypes = require('../constants/actionTypes');

const showModal = () => (dispatch) => {
    dispatch({
        type: actionTypes.BROKER_NO_STOCK_ACCOUNT_MODAL_SHOW
    });
};

const hideModal = () => (dispatch) => {
    dispatch({
        type: actionTypes.BROKER_NO_STOCK_ACCOUNT_MODAL_HIDE
    });
};

module.exports = {
    showModal,
    hideModal
};
